import { envMode } from '@/environment/environment';

class AppAnalyze {
  /**
   * @constructor AppAnalyze
   */
  constructor() {
    /** Initializing the configuration of appAnalyze */
    this.initAppAnalyze();
  }

  initAppAnalyze() {
    // this.pendoInit();
  };

  pendoInit(data) {
    try{
      if('prod' === envMode) {
        // in your authentication promise handler or callback
        pendo.initialize({
          visitor: {
              id:              data.email //'VISITOR-UNIQUE-ID'   // Required if user is logged in
              // email:        // Recommended if using Pendo Feedback, or NPS Email
              // full_name:    // Recommended if using Pendo Feedback
              // role:         // Optional

              // You can add any additional visitor level key-values here,
              // as long as it's not one of the above reserved names.
          },

          account: {
              id:              data.account ? data.account : 'unknown', //'ACCOUNT-UNIQUE-ID' // Highly recommended
              // name:         // Optional
              // is_paying:    // Recommended if using Pendo Feedback
              // monthly_value:// Recommended if using Pendo Feedback
              // planLevel:    // Optional
              // planPrice:    // Optional
              // creationDate: // Optional

              // You can add any additional account level key-values here,
              // as long as it's not one of the above reserved names.
          }
        });
      }
    } catch (e) {}
  }

  pendoTrack(name, data) {
    try{
      if('prod' === envMode) {
        if (pendo && pendo.isReady && pendo.isReady()) {
            return pendo.track(name, data);
        }
        setTimeout(function() {
          pendoTrack(name, data);
        }, 500);
      }
    } catch (e) {}
}

}

/** Creating the instance of appCommons */
const appAnalyze = new AppAnalyze();

export { appAnalyze };
